module.exports = __webpack_public_path__ + "img/8_35.5ea50efb.png";